import { bindPrototypeMethodsToSelf } from '@wix/panorama-common/utils';
import type { ErrorUserData } from '@wix/panorama-common-shared/types';
import type { Breadcrumb, ErrorMonitorOptions } from './types';
import { BasePanoramaClient } from './panorama-client-base';

export interface PanoramaErrorMonitor<T extends ErrorUserData> {
  reportError(error: Error, data?: T): void;

  addBreadcrumb(breadcrumb: Breadcrumb): void;
}

export class PanoramaErrorMonitorImpl<T extends ErrorUserData> {
  constructor(
    private readonly baseClient: BasePanoramaClient,
    private readonly options?: ErrorMonitorOptions,
  ) {
    bindPrototypeMethodsToSelf(this);
  }

  reportError(error: Error, data?: T) {
    this.baseClient.reportError(error, data, this.options);
  }

  addBreadcrumb(breadcrumb: Breadcrumb) {
    this.baseClient.addBreadcrumb(breadcrumb);
  }
}
